import React, { FC } from 'react';

import { LucidTheme, mqMin } from '@lucid/theme';

import Heading from '../heading/heading';
import Box from '../box/box';
import Link from '../link/link';
import Wave from '../wave/wave';
import { ComponentLink } from '../../types/generics';

export interface WaveCtaProps {
  cta?: ComponentLink | null;
  heading: string;
}

const WaveCta: FC<WaveCtaProps> = ({ cta, heading }) => (
  <Wave>
    <Box
      css={(theme: LucidTheme) => ({
        label: 'waveCta',
        textAlign: 'center',
        padding: `${theme.space[0]} ${theme.space[1]}px`,
        [mqMin.tablet]: {
          paddingBottom: theme.space[7]
        }
      })}
    >
      <Heading
        as="h3"
        css={(theme: LucidTheme) => ({ color: theme.colors.white })}
        mb={{ default: 6 }}
        variant="headlineXL"
      >
        {heading}
      </Heading>
      {cta && (
        <Link
          displayAsButton
          css={{ boxShadow: 'none' }}
          to={cta?.linkUrl!}
          variant="primaryAlternate"
        >
          {cta?.linkText!}
        </Link>
      )}
    </Box>
  </Wave>
);

export default WaveCta;
